module.exports = __webpack_public_path__ + "static/media/Mitre.ae58e801.svg";